var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-create-page main-content" },
    [
      !_vm.initLoading
        ? _c(
            "form",
            {
              attrs: { action: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitInvoiceData($event)
                },
              },
            },
            [
              _c("div", { staticClass: "page-header" }, [
                _c("h3", { staticClass: "page-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isEdit
                        ? _vm.$t("islamic_finance.edit_offer_to_Sell")
                        : _vm.$t("islamic_finance.new_offer_to_Sell")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("ol", { staticClass: "breadcrumb" }, [
                  _c(
                    "li",
                    { staticClass: "breadcrumb-item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            slot: "item-title",
                            to: "/supplier/dashboard",
                          },
                          slot: "item-title",
                        },
                        [_vm._v(_vm._s(_vm.$t("general.home")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "breadcrumb-item" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { slot: "item-title", to: "#" },
                          slot: "item-title",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("islamic_finance.title")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("li", { staticClass: "breadcrumb-item" }, [
                    _vm._v(
                      _vm._s(
                        _vm.isEdit
                          ? _vm.$t("islamic_finance.edit_offer_to_Sell")
                          : _vm.$t("islamic_finance.new_offer_to_Sell")
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-actions row" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "invoice-action-btn",
                        attrs: {
                          loading: _vm.isLoading,
                          disabled: _vm.isLoading,
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n\n          " +
                            _vm._s(
                              _vm.isEdit
                                ? _vm.$t("islamic_finance.update_offer_to_Sell")
                                : _vm.$t("islamic_finance.save_offer_to_Sell")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row invoice-input-group" }, [
                _c(
                  "div",
                  { staticClass: "col-md-5 invoice-customer-container" },
                  [
                    _vm.selectedCustomer
                      ? _c("div", { staticClass: "show-customer" }, [
                          _c("div", { staticClass: "row px-2 mt-1" }, [
                            _vm.selectedCustomer.billing_address
                              ? _c("div", { staticClass: "col col-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row address-menu" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "col-sm-4 px-2 title" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("general.bill_to"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm p-0 px-2 content",
                                        },
                                        [
                                          _vm.selectedCustomer.billing_address
                                            .name
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address.name
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.billing_address
                                            .address_street_1
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address
                                                        .address_street_1
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.billing_address
                                            .address_street_2
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address
                                                        .address_street_2
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.billing_address
                                            .city &&
                                          _vm.selectedCustomer.billing_address
                                            .state
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address.city
                                                    ) +
                                                    ", " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address.state
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address.zip
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.billing_address
                                            .country
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address.country
                                                        .name
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.billing_address
                                            .phone
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .billing_address.phone
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedCustomer.shipping_address
                              ? _c("div", { staticClass: "col col-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row address-menu" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "col-sm-4 px-2 title" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("general.ship_to"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm p-0 px-2 content",
                                        },
                                        [
                                          _vm.selectedCustomer.shipping_address
                                            .name
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .shipping_address.name
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.shipping_address
                                            .address_street_1
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .shipping_address
                                                        .address_street_1
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.shipping_address
                                            .address_street_2
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .shipping_address
                                                        .address_street_2
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.shipping_address
                                            .city &&
                                          _vm.selectedCustomer.shipping_address
                                            ? _c("label", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .shipping_address.city
                                                    ) +
                                                    ", " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .shipping_address.state
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.selectedCustomer
                                                        .shipping_address.zip
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.shipping_address
                                            .country
                                            ? _c(
                                                "label",
                                                { staticClass: "country" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.selectedCustomer
                                                          .shipping_address
                                                          .country.name
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.selectedCustomer.shipping_address
                                            .phone
                                            ? _c(
                                                "label",
                                                { staticClass: "phone" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.selectedCustomer
                                                          .shipping_address
                                                          .phone
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "customer-content mb-1" }, [
                            _c("label", { staticClass: "email" }, [
                              _vm._v(_vm._s(_vm.selectedCustomer.name)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "action",
                                on: { click: _vm.editCustomer },
                              },
                              [_vm._v(_vm._s(_vm.$t("general.edit")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "action",
                                on: { click: _vm.removeCustomer },
                              },
                              [_vm._v(_vm._s(_vm.$t("general.deselect")))]
                            ),
                          ]),
                        ])
                      : _c(
                          "base-popup",
                          {
                            class: [
                              "add-customer",
                              {
                                "customer-required":
                                  _vm.$v.selectedCustomer.$error,
                              },
                            ],
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "add-customer-action",
                                attrs: { slot: "activator" },
                                slot: "activator",
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "customer-icon",
                                  attrs: { icon: "user" },
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("customers.new_customer")) +
                                        " "
                                    ),
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(" * "),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.$v.selectedCustomer.$error &&
                                  !_vm.$v.selectedCustomer.required
                                    ? _c("p", { staticClass: "text-danger" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("validation.required")
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("customer-select-popup", {
                              attrs: { type: "offerToSell" },
                            }),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col invoice-input" }, [
                  _c("div", { staticClass: "row mb-3" }, [
                    _c(
                      "div",
                      { staticClass: "col collapse-input" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("islamic_finance.title")) +
                              " " +
                              _vm._s(_vm.$t("invoices.date"))
                          ),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(" * "),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("base-date-picker", {
                          attrs: {
                            "calendar-button": true,
                            "calendar-button-icon": "calendar",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$v.newInvoice.offer_to_sell_date.$touch()
                            },
                          },
                          model: {
                            value: _vm.newInvoice.offer_to_sell_date,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.newInvoice,
                                "offer_to_sell_date",
                                $$v
                              )
                            },
                            expression: "newInvoice.offer_to_sell_date",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.newInvoice.offer_to_sell_date.$error &&
                        !_vm.$v.newInvoice.offer_to_sell_date.required
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("validation.required")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col collapse-input" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("islamic_finance.delivery_date"))
                          ),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(" * "),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("base-date-picker", {
                          attrs: {
                            invalid: _vm.$v.newInvoice.delivery_date.$error,
                            "calendar-button": true,
                            disabled: true,
                            "calendar-button-icon": "calendar",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$v.newInvoice.delivery_date.$touch()
                            },
                          },
                          model: {
                            value: _vm.newInvoice.delivery_date,
                            callback: function ($$v) {
                              _vm.$set(_vm.newInvoice, "delivery_date", $$v)
                            },
                            expression: "newInvoice.delivery_date",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.newInvoice.delivery_date.$error &&
                        !_vm.$v.newInvoice.delivery_date.required
                          ? _c("span", { staticClass: "text-danger mt-1" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("validation.required"))
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-4" }, [
                    _c(
                      "div",
                      { staticClass: "col collapse-input" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("islamic_finance.payment_date"))
                          ),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(" * "),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("base-date-picker", {
                          attrs: {
                            invalid: _vm.$v.newInvoice.payment_date.$error,
                            "calendar-button": true,
                            disabled: true,
                            "calendar-button-icon": "calendar",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$v.newInvoice.payment_date.$touch()
                            },
                          },
                          model: {
                            value: _vm.newInvoice.payment_date,
                            callback: function ($$v) {
                              _vm.$set(_vm.newInvoice, "payment_date", $$v)
                            },
                            expression: "newInvoice.payment_date",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.newInvoice.payment_date.$error &&
                        !_vm.$v.newInvoice.payment_date.required
                          ? _c("span", { staticClass: "text-danger mt-1" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("validation.required"))
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "item-table" },
                [
                  _c("colgroup", [
                    _c("col", { staticStyle: { width: "2%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "20%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "20%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "10%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "15%" } }),
                    _vm._v(" "),
                    _vm.discountPerItem === "YES"
                      ? _c("col", { staticStyle: { width: "15%" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "15%" } }),
                  ]),
                  _vm._v(" "),
                  _c("thead", { staticClass: "item-table-header" }, [
                    _c("tr", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-left" }, [
                        _c("span", { staticClass: "column-heading" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$tc("items.item", 2)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-left" }, [
                        _c("span", { staticClass: "column-heading" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$tc("items.part_number", 2)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-left" }, [
                        _c("span", { staticClass: "column-heading" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("invoices.item.quantity")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-left" }, [
                        _c("span", { staticClass: "column-heading" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("invoices.item.price")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.discountPerItem === "YES"
                        ? _c("th", { staticClass: "text-right" }, [
                            _c("span", { staticClass: "column-heading" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("invoices.item.discount")) +
                                  "\n            "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-right" }, [
                        _c(
                          "span",
                          { staticClass: "column-heading amount-heading" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("invoices.item.amount")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "item-body",
                      attrs: { tag: "tbody", handle: ".handle" },
                      model: {
                        value: _vm.newInvoice.items,
                        callback: function ($$v) {
                          _vm.$set(_vm.newInvoice, "items", $$v)
                        },
                        expression: "newInvoice.items",
                      },
                    },
                    _vm._l(_vm.newInvoice.items, function (item, index) {
                      return _c("offer-to-sell-item", {
                        key: item.id,
                        attrs: {
                          index: index,
                          "item-data": item,
                          "invoice-items": _vm.newInvoice.items,
                          currency: _vm.currency,
                          "tax-per-item": _vm.taxPerItem,
                          "discount-per-item": _vm.discountPerItem,
                          type: _vm.OfferToSellItemType,
                        },
                        on: {
                          remove: _vm.removeItem,
                          update: _vm.updateItem,
                          itemValidate: _vm.checkItemsData,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-item-action", on: { click: _vm.addItem } },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "shopping-basket" },
                  }),
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("invoices.add_item")) + "\n    "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "invoice-foot" }, [
                _c(
                  "div",
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("invoices.notes")))]),
                    _vm._v(" "),
                    _c("base-text-area", {
                      attrs: { rows: "3", cols: "50" },
                      model: {
                        value: _vm.newInvoice.notes,
                        callback: function ($$v) {
                          _vm.$set(_vm.newInvoice, "notes", $$v)
                        },
                        expression: "newInvoice.notes",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "invoice-total" }, [
                  _c("div", { staticClass: "section" }, [
                    _c("label", { staticClass: "invoice-label" }, [
                      _vm._v(_vm._s(_vm.$t("invoices.sub_total"))),
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "invoice-amount" }, [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$utils.formatMoney(_vm.subtotal, _vm.currency)
                          ),
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.taxPerItem === "NO" || _vm.taxPerItem === null
                    ? _c(
                        "div",
                        _vm._l(_vm.newInvoice.taxes, function (tax, index) {
                          return _c("tax", {
                            key: tax.id,
                            attrs: {
                              index: index,
                              total: _vm.subtotalWithDiscount,
                              tax: tax,
                              taxes: _vm.newInvoice.taxes,
                              currency: _vm.currency,
                              "total-tax": _vm.totalSimpleTax,
                            },
                            on: {
                              remove: _vm.removeInvoiceTax,
                              update: _vm.updateTax,
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "section border-top mt-3" }, [
                    _c("label", { staticClass: "invoice-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("invoices.total")) +
                          " " +
                          _vm._s(_vm.$t("invoices.amount")) +
                          ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "invoice-amount total" }, [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$utils.formatMoney(_vm.total, _vm.currency)
                          ),
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _c("base-loader"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "text-left" }, [
      _c("span", { staticClass: "column-heading item-checkbox" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }